module.exports = __webpack_public_path__ + "img/home_bg0.935aae58.png";